import { Navigate, useParams } from "react-router-dom";

interface RedirectWithParamsProps {
  to: string;
}

/**
 * A redirect component that preserves URL parameters
 * Used for 301 redirects from old URLs to new SEO-optimized URLs
 */
const RedirectWithParams = ({ to }: RedirectWithParamsProps) => {
  const params = useParams();
  
  // Replace :param placeholders with actual values
  let targetPath = to;
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      targetPath = targetPath.replace(`:${key}`, value);
    }
  });
  
  return <Navigate to={targetPath} replace />;
};

export default RedirectWithParams;
